import React, {useState, useEffect} from 'react';
import {db} from "./firebase";
import Order from './Order';
import './Orders.css'
import {useStateValue} from "./StateProvider";
import empty from './Imagenes/empty.png'

function Orders() {
    const[{ basket, user}, dispatch]= useStateValue();
    const [orders, setOrders]= useState([]);
   

    useEffect(() => {
        if(user) {
            db
        .collection('users')
        .doc(user?.uid)
        .collection('orders')
        .orderBy('created', 'desc')
        .onSnapshot(snapshot => (
            setOrders(snapshot.docs.map(doc => ({
                id: doc.id,
                data: doc.data()
            })))
        
            
        ))
        
    } 
    else {
            setOrders([])
    }
    }, [user])

    return (
        <div className='orders'>
           <h1>Tus pedidos:</h1> 
           
           <div className= 'orders_order'>
           <img className= "empty_orders"
                src={empty}
                alt=""
                />
               {orders?.map(order => (
                   <Order key="orders" order={order} />
               ))}
               
           </div>
           <div></div>
        </div>
    )
}

export default Orders
